export function getOrderStatusTitle({
  payStatus: status,
  refundStatus,
  promType,
  orderStatusCode: code,
  orderGoodsList,
}) {
  switch (code) {
    case 'WAITPAY':
      if (promType === 4) {
        return '定金待买家付款';
      }
      return '等待买家付款';
    case 'WAITSEND':
      return '买家已付款';
    case 'WAITRECEIVE':
      if (orderGoodsList.some(f => !f.deliveryId)) {
        return '卖家已部分发货';
      }
      return '卖家已发货';
    case 'WAITCCOMMENT':
      return '交易成功';
    case 'PORTIONSEND':
      return '部分发货';
    case 'PAY_DEPOSIT':
      return '已付定金';
    case 'WAIT_PAY_RETAINAGE':
      return '待付尾款';
    case 'CANCEL':
      if (status === 1) {
        return '退款处理中';
      } else if (status === 3) {
        return '交易关闭 退款成功';
      } else if (status === 4) {
        return '交易关闭 拒绝退款';
      }
      return '订单已取消';
    case 'REFUND':
      return '买家已付款 拒绝退款';
    case 'FINISH':
      return '交易完成';
    case 'CANCELLED':
      if (refundStatus === 2) {
        return '交易关闭 退款成功';
      } else if (promType === 4) {
        return '交易关闭 尾款支付超时';
      }
      return '交易关闭';
    case 'CANCEL_REFUND':
      return '交易关闭 退款成功';
    default:
      return '';
  }
}

export function isWaitPay(code) {
  return code === 'WAITPAY';
}

export function isPayDeposit(code) {
  return code === 'PAY_DEPOSIT';
}

export function isNotPayEndPrice(code) {
  return code === 'WAIT_PAY_RETAINAGE';
}

export function showAddress(data, defaulVal) {
  const {
    province: {
      name: name1,
    },
    city: {
      name: name2,
    },
    district: {
      name: name3,
    },
    address,
  } = data;
  return name1 ? name1 + name2 + name3 + address : (defaulVal || '');
}

export function getOrderRefundTitle({
  refundId,
  refundType,
  isApplyRefund,
  refundStatus,
}) {
  if (isApplyRefund && refundId) {
    switch (refundStatus) {
      case -1:
        return '售后被拒';
      case 0:
        return '售后审核中';
      case 1:
        return '售后通过，待寄回';
      case 2:
        return '售后中，待商家收货';
      case 3:
        return refundType === 2 ? '售后中，待商家重新发货' : '售后中，待商家退款';
      case 4:
        return '售后中，待用户收货';
      case 5:
        return '售后完成';
      default:
        return '售后处理中';
    }
  }
}
